<template>
  <div class="min-h-screen px-4">
    <div class="" v-if="loading">
      <loader class="center-h-v" />
    </div>
    <div class="bg-yellow-200 py-2 px-2 rounded mb-5" v-if="notAssignedReportingTo.length >1">
      Your organogram is not properly set up. Please assign a reporting to for all job titles. Click <a class="underline font-bold" href="core-setup/job-titles">here</a>  to update the job titles
    </div>
    <div id="orgchart"></div>
    <PreviewEmployeeDetails
    :show-employee-details="isModalVisible"
    :employee-details="selectedEmployee"
    @close = "isModalVisible = false"
    />
  </div>

</template>

<script>
// import { GChart } from "vue-google-charts/legacy";
/* global google */
import { mapGetters } from "vuex";
import axios from "axios";
import decryptData from "@/utils/decrypt";
import PreviewEmployeeDetails from "@/components/company/employeeDetailsModal";
export default {
  name: "GoogleChart",
  components: {PreviewEmployeeDetails},
  data() {
    return {
      organogram: [],
      loading: false,
      notAssignedReportingTo:[],
      isModalVisible: false,
      selectedEmployee: {},
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getOrganogram()
    this.loadGoogleCharts();
    google.charts.setOnLoadCallback(this.drawChart);
  },
  methods: {
    loadGoogleCharts() {
      const script = document.createElement('script');
      script.src = 'https://www.gstatic.com/charts/loader.js';
      script.onload = () => {
        google.charts.load('current', { packages: ['orgchart'] });
        google.charts.setOnLoadCallback(this.drawChart);
      };
      document.head.appendChild(script);
    },
    showEmployeeDetails(employee) {
      this.selectedEmployee = employee;  // Set employee details
      this.isModalVisible = true;        // Show modal
    },
    drawChart() {
      const chartData = this.organogram.map(item => {
        const employeesList = item.Employees && item.Employees.length > 0
            ? `<ul>${item.Employees.map(emp => `
              <li><span class="employee-name underline text-black/50" data-employee='${JSON.stringify(emp)}'
                    style="cursor: pointer;">
                  ${decryptData(emp.Fullname, this.$decryptionKey)}
                  </span>
              </li>`).join('')}</ul>`
            : '';
        return [
          { v: item.Id, f:`<div class="node-card " style="width: 150px !important;">
                  <strong>${item.Name}</strong>
                  ${employeesList}
                </div>` },
          item.ReportsToId || '',
          ''
        ];
      });
      const data = new google.visualization.DataTable();
      // First column: 'Name'
      // This column will store the unique identifier (Id) for each node in the chart.
      // It also includes the HTML-formatted content (with the name and description) that will be displayed in the box.
      data.addColumn('string', 'Name');
      // Second column: 'Manager'
      // This column specifies the Id of the node's parent (i.e., the manager or the node it reports to).
      // If a node does not report to any other node (e.g., a CEO), this field should be left blank.
      data.addColumn('string', 'Manager');
      // Third column: 'ToolTip'
      // This optional column allows you to specify additional information that appears when the user hovers over a node.
      // It can be used for extra details or context, enhancing the user experience.
      data.addColumn('string', 'ToolTip');
      data.addRows(chartData);

      const chart = new google.visualization.OrgChart(document.getElementById('orgchart'));
      chart.draw(data, { allowHtml: true });
      document.querySelectorAll('.employee-name').forEach(el => {
        el.addEventListener('click', (event) => {
          const employeeData = JSON.parse(event.target.getAttribute('data-employee'));
          this.showEmployeeDetails(employeeData);  // Show modal with employee details
        });
      });
    },
    async getOrganogram() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      try {
        const response = await axios.get(
            `${this.getOrganization}/organization/organogram/${this.$ApiVersion}/request`,
            options
        );
        this.loading = false;
        if (response.data.StatusCode === 200) {
          console.log(response.data.Data)
          this.organogram = response.data.Data
          this.notAssignedReportingTo = response.data.Data.filter(item => {
            return item.ReportsToId === null;
          });
          this.drawChart();
        } else {
          console.log("No data found");
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching organogram data:", error.message);
      }
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.google-visualization-orgchart-node {
  background: white !important;
  background-color: white !important;
}
.node-card {
  padding: .5rem;
  margin: 0;

  border-radius: 5px;
}
.google-visualization-orgchart-table {

}
</style>
